@if (displayObjectService.displayObject$ | async; as displayObject) {
  @if (displayObject.type === 'group') {
    <vitamui-common-group [displayObject]="displayObject"></vitamui-common-group>
  }
  @if (displayObject.type === 'list') {
    <vitamui-common-list [displayObject]="displayObject"></vitamui-common-list>
  }
  @if (displayObject.type === 'primitive') {
    <vitamui-common-primitive [displayObject]="displayObject"></vitamui-common-primitive>
  }
}
